import IconButton from '@mui/material/IconButton';
import Tooltip, { TooltipProps } from '@mui/material/Tooltip';

import React from 'react';

type InfoTooltipProps = TooltipProps;

const InfoTooltip: React.FC<InfoTooltipProps> = (props: TooltipProps) => {
	const { children } = props;
	return (
		<Tooltip {...props}>
			<IconButton disableRipple>{children}</IconButton>
		</Tooltip>
	);
};

export default InfoTooltip;
